<template>
  <modal :show.sync="openDirectPayoutDetailsModal"
    size="lg">
    <b-row class="approval-direct-payout" v-if="currentCommsPayoutSummary">
        <b-col cols="12">
            <h4 class="mb-3">Direct, Recruitment and Pool Payout Details</h4>
            <b-row>
              <b-col cols="12" md="6">
                <table class="table table-bordered">
                  <thead>
                      <tr>
                        <th class="bg-primary text-white py-2" width="150px">Comms Payout Summary ID</th>
                        <td class="py-2">#{{ currentCommsPayoutSummary.comms_payout_summary_id }}</td>
                      </tr>
                      <template v-if="currentCommsPayoutSummary.case">
                        <tr>
                          <th class="bg-primary text-white py-2">Case ID</th>
                          <td class="py-2">#{{ currentCommsPayoutSummary.case.prod_id }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Customer Name</th>
                          <td class="py-2">{{ currentCommsPayoutSummary.case.prod_customer_name }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Product Type</th>
                          <td class="py-2">{{ currentCommsPayoutSummary.case.prod_type }}</td>
                        </tr>
                      </template>
                      <tr>
                        <th class="bg-primary text-white py-2">Net Price</th>
                        <td class="py-2">{{ currentCommsPayoutSummary.cps_develop_nett_price | moneyFormatter }}</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Hub</th>
                        <td class="py-2" v-if="currentCommsPayoutSummary.hub">{{ currentCommsPayoutSummary.hub.hub_name }} | {{ currentCommsPayoutSummary.hub.hub_team.hub_team_name }} | {{ currentCommsPayoutSummary.hub.hub_team.hub_team_leader.name }}</td>
                      </tr>
                  </thead>
                </table>
              </b-col>
              <b-col cols="12" md="6">
                <table class="table table-bordered">
                  <thead>
                      <tr>
                        <th class="bg-primary text-white py-2" width="150px">Total Revenue Point</th>
                        <td class="py-2">RM {{ currentCommsPayoutSummary.cps_total_revenue_point | moneyFormatter }}</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Direct Payout ({{ currentCommsPayoutSummary.cps_direct_payout_allocation_percentage }} %)</th>
                        <td class="py-2">RM {{ currentCommsPayoutSummary.cps_balance_revenue_point | moneyFormatter }}</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Pool Payout ({{ currentCommsPayoutSummary.cps_pool_allocation_percentage }} %)</th>
                        <td class="py-2">RM {{ currentCommsPayoutSummary.cps_pool_revenue_point | moneyFormatter }}</td>
                      </tr>
                  </thead>
                </table>
              </b-col>
            </b-row>

            <div>Direct Payout</div>
            <table class="table table-bordered" width="50%">
                <thead>
                  <tr>
                      <th class="bg-dark text-white py-2">#</th>
                      <th class="bg-dark text-white py-2">User</th>
                      <th class="bg-dark text-white py-2">Payout Level</th>
                      <th class="bg-dark text-white py-2">Total Revenue Point</th>
                      <th class="bg-dark text-white py-2">Payout <br>Percentage <br>(%)</th>
                      <th class="bg-dark text-white py-2">Payout <br>Revenue Point</th>
                      <!-- <th class="bg-dark text-white py-1" width="200px">Manager Approval Status</th>
                      <th class="bg-dark text-white py-1" width="200px">Finance Approval Status</th>
                      <th class="bg-dark text-white py-1" width="200px">CEO Approval Status</th> -->
                    </tr>
                </thead>
                <tbody>
                  <template>
                    <tr v-for="(direct_payout_detail, index) in currentCommsPayoutSummary.direct_payout_details" :key="index">
                      <td class="py-2">{{ index+1 }}</td>
                      <td class="py-2">{{ direct_payout_detail.user.name }}</td>
                      <td class="py-2">{{ direct_payout_detail.payout_level_code }}</td>
                      <td class="py-2">RM {{ direct_payout_detail.total_revenue_point | moneyFormatter }}</td>
                      <td class="py-2">{{ direct_payout_detail.payout_percentage }}</td>
                      <td class="py-2">RM {{ direct_payout_detail.payout_revenue_point | moneyFormatter }}</td>
                      <!-- <template v-if="decide_mode">
                          <td class="py-1">
                              <el-select
                                  v-model="direct_payout_detail.manager_approval_status" :disabled="permission.admin === false ? !permission.acceptor : !permission.admin"
                              >
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                          </td>
                          <td class="py-1">
                              <el-select
                                  v-model="direct_payout_detail.finance_approval_status" value-key="label" :disabled="permission.admin === false ? !permission.reviewer : !permission.admin"
                              >
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                          </td>
                          <td class="py-1">
                              <el-select
                                  v-model="direct_payout_detail.ceo_approval_status" :disabled="permission.admin === false ? !permission.approver : !permission.admin"
                              >
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                />
                              </el-select>
                          </td>
                      </template>
                      <template v-else>
                          <td class="py-1">{{ direct_payout_detail.manager_approval_status_name }}</td>
                          <td class="py-1">{{ direct_payout_detail.finance_approval_status_name }}</td>
                          <td class="py-1">{{ direct_payout_detail.ceo_approval_status_name }}</td>
                      </template> -->
                    </tr>
                  </template>
                </tbody>
            </table>
            
            <RecruitmentPayoutDetails 
            :currentCommsPayoutSummary="currentCommsPayoutSummary"
            :decide_mode="decide_mode"
            :options="options"
            :permission="permission" />

            <PoolContributionDetails 
            :currentCommsPayoutSummary="currentCommsPayoutSummary"
            />
            
            <template v-if="currentCommsPayoutSummary.hub_pending_approval">
              <b-form-group
                label="Hub Manager Remark"
              >
                <b-form-textarea
                    id="acceptor_remark"
                    v-model="currentCommsPayoutSummary.hub_pending_approval.acceptor_remark"
                    :disabled="permission.admin === false ? !permission.acceptor : !permission.admin"
                    placeholder="Enter some remark ..."
                    rows="4"
                    max-rows="4"
                >
                </b-form-textarea>
              </b-form-group>
              <b-form-group
                label="Finance Remark"
              >
                <b-form-textarea
                    id="reviewer_remark"
                    v-model="currentCommsPayoutSummary.hub_pending_approval.reviewer_remark"
                    :disabled="permission.admin === false ? !permission.reviewer : !permission.admin"
                    placeholder="Enter some remark ..."
                    rows="4"
                    max-rows="4"
                >
                </b-form-textarea>
              </b-form-group>
              <b-form-group
                label="CEO Remark"
              >
                <b-form-textarea
                    id="approver_remark"
                    v-model="currentCommsPayoutSummary.hub_pending_approval.approver_remark"
                    :disabled="permission.admin === false ? !permission.approver : !permission.admin"
                    placeholder="Enter some remark ..."
                    rows="4"
                    max-rows="4"
                >
                </b-form-textarea>
              </b-form-group>
            </template>

            <template>
              <b-row>
                <b-col cols="12" md="3">
                  <table class="table table-bordered" v-if="currentCommsPayoutSummary.hub_pending_approval">
                    <thead>
                        <tr>
                          <th class="bg-primary text-white py-2" width="150px">Hub Manager Approval</th>
                          <td class="py-2">{{ currentCommsPayoutSummary.hub_pending_approval.is_accepted_status_name }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Reviewer Approval</th>
                          <td class="py-2">{{ currentCommsPayoutSummary.hub_pending_approval.is_reviewed_status_name }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">CEO Approval</th>
                          <td class="py-2">{{ currentCommsPayoutSummary.hub_pending_approval.is_approved_status_name }}</td>
                        </tr>
                    </thead>
                  </table>
                </b-col>
              </b-row>
                
            </template>
            <div class="text-red" v-if="permission.admin">**Note: You action of approval, will bypass all others approvers' approval process. <br>When you click on the below buttons, all the approvals will be fully done by you.</div>
        </b-col>
    </b-row>
    <template slot="footer" v-if="decide_mode">
      <div class="d-flex justify-content-end w-100" v-if="permission.acceptor">
        <base-button type="danger" @click="acceptorAction(0)">Reject</base-button>
        <base-button type="success" @click="acceptorAction(1)">Approve</base-button>
      </div>
      <div class="d-flex justify-content-end w-100" v-if="permission.reviewer">
        <base-button type="danger" @click="reviewerAction(0)">Reject</base-button>
        <base-button type="success" @click="reviewerAction(1)">Approve</base-button>
      </div>
      <div class="d-flex justify-content-end w-100" v-if="permission.approver">
        <base-button type="danger" @click="approverAction(0)">Reject</base-button>
        <base-button type="success" @click="approverAction(1)">Approve</base-button>
      </div>
      <div class="d-flex justify-content-end w-100" v-if="permission.admin">
        <base-button type="danger" @click="adminAction(0)">Reject</base-button>
        <base-button type="success" @click="adminAction(1)">Approve</base-button>
      </div>
    </template>
</modal>
</template>
<style>
  .approval-direct-payout .el-select .el-input .el-input__inner{
    height: 25px;
  }
  .approval-direct-payout .el-select .el-input .el-select__caret{
    margin-top: 10px;
  }
  .approval-direct-payout .el-select .el-input.is-focus .el-input__inner{
    border: none;
  }
  .approval-direct-payout .el-select .el-input .el-input__inner:focus{
    border: none;
  }
</style>
<script>
import { Select, Option } from 'element-ui'
import { notifyFunctionMixin,axios,services,getHeader,swal, helperFunctionMixin } from '@/assets/js/httpImports.js'
import RecruitmentPayoutDetails from './RecruitmentPayoutDetails.vue';
import PoolContributionDetails from './PoolContributionDetails.vue';

export default {
props: ['showDirectPayoutDetails', 'currentCommsPayoutSummary','decide_mode', 'permission'],
mixins: [notifyFunctionMixin, helperFunctionMixin],
components: {
      [Select.name]: Select,
      [Option.name]: Option,
      RecruitmentPayoutDetails,
      PoolContributionDetails,
    },
data() {
    return {
        openDirectPayoutDetailsModal: false,
        form: {},
        options: [
          {
            value: 1,
            label: 'Approve',
          },
          {
            value: 0,
            label: 'Reject',
          },
        ]
    }
},

created() {
},
methods:{
  updateDirectPayoutDetail(type, approval_status) {
    
    let formData = this.currentCommsPayoutSummary.direct_payout_details

    if(approval_status == 0)
    {
      switch(type)
      {
        case 'accept':
          formData.forEach((item) => {
            item.manager_approval_status = 0;
          }); 
        break;
        case 'review':
          formData.forEach((item) => {
            item.finance_approval_status = 0;
          }); 
        break;
        case 'approve':
          formData.forEach((item) => {
            item.ceo_approval_status = 0;
          }); 
        break;
        case 'admin':
          formData.forEach((item) => {
            item.manager_approval_status = 0;
            item.ceo_approval_status = 0;
            item.finance_approval_status = 0;
          }); 
        break;
      }
    }
    else
    { 
      switch(type)
      {
        case 'accept':
          formData.forEach((item) => {
            item.manager_approval_status = 1;
          }); 
        break;
        case 'review':
          formData.forEach((item) => {
            item.finance_approval_status = 1;
          }); 
        break;
        case 'approve':
          formData.forEach((item) => {
            item.ceo_approval_status = 1;
          }); 
        break;
        case 'admin':
          formData.forEach((item) => {
            item.manager_approval_status = 1;
            item.ceo_approval_status = 1;
            item.finance_approval_status = 1;
          }); 
        break;
      }
    }

    axios.put(services.hub + 'hub_comms/direct_payout_detail/'+this.currentCommsPayoutSummary.comms_payout_summary_id, formData, {headers: getHeader()})
    .then(res  => {
      this.notifySuccess('<b>Direct Payout Details: </b> - Successfully Updated.')
    })
    .catch(e => {
      this.errorFunction(e)
    })
  },
  updateRecruitmentPayoutDetail(type, approval_status) {
    let formData = this.currentCommsPayoutSummary.recruitment_payout_details

    if(approval_status == 0)
    {
      switch(type)
      {
        case 'accept':
          formData.forEach((item) => {
            item.manager_approval_status = 0;
          }); 
        break;
        case 'review':
          formData.forEach((item) => {
            item.finance_approval_status = 0;
          }); 
        break;
        case 'approve':
          formData.forEach((item) => {
            item.ceo_approval_status = 0;
          }); 
        break;
        case 'admin':
          formData.forEach((item) => {
            item.manager_approval_status = 0;
            item.ceo_approval_status = 0;
            item.finance_approval_status = 0;
          }); 
        break;
      }
    }
    else
    {
      switch(type)
      {
        case 'accept':
          formData.forEach((item) => {
            item.manager_approval_status = 1;
          }); 
        break;
        case 'review':
          formData.forEach((item) => {
            item.finance_approval_status = 1;
          }); 
        break;
        case 'approve':
          formData.forEach((item) => {
            item.ceo_approval_status = 1;
          }); 
        break;
        case 'admin':
          formData.forEach((item) => {
            item.manager_approval_status = 1;
            item.ceo_approval_status = 1;
            item.finance_approval_status = 1;
          }); 
        break;
      }
    }
    axios.put(services.hub + 'hub_comms/recruitment_payout_detail/'+this.currentCommsPayoutSummary.comms_payout_summary_id, formData, {headers: getHeader()})
    .then(res  => {
      this.notifySuccess('<b>Recruitment Payout Details: </b> - Successfully Updated.')
    })
    .catch(e => {
      this.errorFunction(e)
    })
  },
  acceptorAction(is_accepted) {
    if(is_accepted == 0)
    {
      swal.fire({
      title: 'Are you sure?',
      text: "This will reject the approval!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.acceptorUpdate(is_accepted);
        }
      })
    }
    else
    {
      this.acceptorUpdate(is_accepted);
    }
  },
  acceptorUpdate(is_accepted) {
    this.updateDirectPayoutDetail('accept', is_accepted);
    this.updateRecruitmentPayoutDetail('accept', is_accepted);

    const postData = {
      is_accepted: is_accepted,
      acceptor_remark: this.currentCommsPayoutSummary.hub_pending_approval.acceptor_remark
    };

    axios.put(services.hub + 'hub_comms/hub_pending_approval.accept/' + this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id, postData, { headers: getHeader() })
    .then(res => {
      if(res.status === 200)
      {
        this.openDirectPayoutDetailsModal = false;
        this.$emit('refetch-comms-payout-details');
        this.$notify({
          message:
          '<b>Approval Process Completed : #'+ this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id,
          timeout: 2000,
          icon: 'ni ni-bell-55',
          type: 'default',
        });
      }
    })
    .catch ( error => {
        this.errorFunction(error, "Update hub pending approval failed: " + error.response.data.message) 
    });
  },
  reviewerAction(is_reviewed) {
    if(is_reviewed == 0)
    {
      swal.fire({
      title: 'Are you sure?',
      text: "This will reject the approval!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.reviewerUpdate(is_reviewed);
        }
      });
    }
    else
    {
      this.reviewerUpdate(is_reviewed);
    }
  },
  reviewerUpdate(is_reviewed) {
    this.updateDirectPayoutDetail('review', is_reviewed);
    this.updateRecruitmentPayoutDetail('review', is_reviewed);

    const postData = {
      is_reviewed: is_reviewed,
      reviewer_remark: this.currentCommsPayoutSummary.hub_pending_approval.reviewer_remark
    };

    axios.put(services.hub + 'hub_comms/hub_pending_approval.review/' + this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id, postData, { headers: getHeader() })
    .then(res => {
      if(res.status === 200)
      {
        this.openDirectPayoutDetailsModal = false;
        this.$emit('refetch-comms-payout-details');
        this.$notify({
          message:
          '<b>Approval Process Completed : #'+ this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id,
          timeout: 2000,
          icon: 'ni ni-bell-55',
          type: 'default',
        });
      }
    })
    .catch ( error => {
        this.errorFunction(error, "Update hub pending approval failed: " + error.response.data.message) 
    });
  },
  approverAction(is_approved) {
    const postData = {
      is_approved: is_approved,
      approver_remark: this.currentCommsPayoutSummary.hub_pending_approval.approver_remark,
      approver_value: this.currentCommsPayoutSummary,
    };
    swal.fire({
      title: 'Are you sure?',
      text: "This is the last approval stage, please read through carefully!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.updateDirectPayoutDetail('approve', is_approved);
        this.updateRecruitmentPayoutDetail('approve', is_approved);

        axios.put(services.hub + 'hub_comms/hub_pending_approval.approval/' + this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id, postData, { headers: getHeader() })
        .then(res => {
          if(res.status === 200)
          {
            this.openDirectPayoutDetailsModal = false;
            this.$emit('refetch-comms-payout-details');
            this.$notify({
              message:
              '<b>Approval Process Completed : #'+ this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id,
              timeout: 2000,
              icon: 'ni ni-bell-55',
              type: 'default',
            });
          }
        })
        .catch ( error => {
            this.errorFunction(error, "Update hub pending approval failed: " + error.response.data.message) 
        });
      }
    })
  },
  adminAction(is_admin_approved) {
    const postData = {
      is_accepted: is_admin_approved,
      acceptor_remark: this.currentCommsPayoutSummary.hub_pending_approval.acceptor_remark,
      is_reviewed: is_admin_approved,
      reviewer_remark: this.currentCommsPayoutSummary.hub_pending_approval.reviewer_remark,
      is_approved: is_admin_approved,
      approver_remark: this.currentCommsPayoutSummary.hub_pending_approval.approver_remark,
      approver_value: this.currentCommsPayoutSummary,
    };

    swal.fire({
      title: 'Are you sure?',
      text: "This is the last approval stage, please read through carefully!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.updateDirectPayoutDetail('admin', is_admin_approved);
        this.updateRecruitmentPayoutDetail('admin', is_admin_approved);

        axios.put(services.hub + 'hub_comms/hub_pending_approval.admin_approval/' + this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id, postData, { headers: getHeader() })
        .then(res => {
          if(res.status === 200)
          {
            this.openDirectPayoutDetailsModal = false;
            this.$emit('refetch-comms-payout-details');
            this.$notify({
              message:
              '<b>Approval Process Completed : #'+ this.currentCommsPayoutSummary.hub_pending_approval.hub_pending_approval_id,
              timeout: 2000,
              icon: 'ni ni-bell-55',
              type: 'default',
            });
          }
        })
        .catch ( error => {
            this.errorFunction(error, "Update hub pending approval failed: " + error.response.data.message) 
        });
      }
    })
  },
},
watch:{
    showDirectPayoutDetails(newVal){
      if(newVal){
          this.openDirectPayoutDetailsModal = true
      }
    },
    openDirectPayoutDetailsModal(newVal){
      if(!newVal){
          this.$emit("close-modal");
      }
    },
},
}  
</script>